import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDialog, {
    attrs: {
      "data-qa": "alert_dialog",
      size: "sm",
      title: _setup.dialogData.title,
      persistent: _setup.dialogData.persistent,
    },
    scopedSlots: _vm._u(
      [
        _setup.dialogData.text
          ? {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "text-body-1 text-secondary--text",
                      attrs: { "data-qa": "alert_dialog_text" },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_setup.dialogData.text) + "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "actions",
          fn: function () {
            return [
              _setup.dialogData.cancel?.text
                ? _c(
                    VBtn,
                    {
                      attrs: {
                        "data-qa": "alert_dialog_cancel",
                        color: _setup.dialogData.confirm?.text
                          ? "text"
                          : "primary",
                        text: "",
                      },
                      on: { click: _setup.handleCancel },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.dialogData.cancel.text) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.dialogData.confirm?.text
                ? _c(
                    VBtn,
                    {
                      attrs: {
                        "data-qa": "alert_dialog_confirm",
                        color: "primary",
                        text: "",
                      },
                      on: { click: _setup.handleConfirm },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.dialogData.confirm.text) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
    model: {
      value: _setup.isOpened,
      callback: function ($$v) {
        _setup.isOpened = $$v
      },
      expression: "isOpened",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }